// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__2GDb5","light":"Button_light__1VN_B","info":"Button_info__3Jf1r","secondary":"Button_secondary__14ViE","primary":"Button_primary__2_LLg"};